<module-container>
  <div class="title-container">
    <h2>OCR Flow</h2>
  </div>
  <div class="flow-contianer">
    <mat-accordion multi="true">
      <mat-expansion-panel
        *ngFor="let flo of flow; index as flowIndex"
        class="job-container"
        [expanded]="flo.id == 1 || flo.id == 2"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="job-header">{{ getFromSet(jobSet, flo.id) }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div *ngFor="let client of flo.clients; index as clientIndex" class="client-container">
          <span class="client-header">{{ getFromSet(clientSet, client.id) }}</span>
          <div
            *ngFor="let channel of client.channels; index as channelIndex"
            class="channel-container"
          >
            <span class="channel-header">{{ getFromSet(channelSet, channel.id) }}</span>
            <mat-slide-toggle
              [checked]="channel.isRunning"
              (change)="toggleChange(flowIndex, clientIndex, channelIndex)"
            ></mat-slide-toggle>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</module-container>
